// extracted by mini-css-extract-plugin
export var icon = "_6o-3";
export var subtitle = "_6o-2";
export var title = "_6o-1";
export var value = "_6o-0";